// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

// ** Leads
export const getLeadsList = createAsyncThunk('appLeads/getLeadsList', async params => {   
    params.page = params.page === 0 ? 0 : params.page - 1
    const response = await axios.post(`https://api.mfauto.com.ua/leads/list?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...params,
        token: localStorage.getItem('token')
    })

    return {
        params,
        data: response.data.leads,
        totalPages: response.data.total_elements
    }
})

export const addLead = createAsyncThunk('appLeads/addLead', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/leads/add?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })
    return response.data
})

export const updateLead = createAsyncThunk('appLeads/updateLead', async (data) => {
    const response = await axios.post(`https://api.mfauto.com.ua/leads/edit?env=${process.env.REACT_APP_NODE_ENV}`, {
        ...data,
        token: localStorage.getItem('token')
    })
    return response.data
})
export const getLead = createAsyncThunk('appLeads/getLead', async (id) => {
    const response = await axios.post(`https://api.mfauto.com.ua/leads/get?env=${process.env.REACT_APP_NODE_ENV}`, {
        id,
        token: localStorage.getItem('token')
    })
    return response.data
})
export const removeLead = createAsyncThunk('appLeads/removeLead', async (id) => {
    const response = await axios.post(`https://api.mfauto.com.ua/leads/remove?env=${process.env.REACT_APP_NODE_ENV}`, {
        id,
        token: localStorage.getItem('token')
    })
    return response.data
})

export const appLeadsSlice = createSlice({
    name: 'appLeads',
    initialState: {        
        data: [],
        total: 1,    
        params: {},
        settings: [],
        selectedLead: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getLeadsList.fulfilled, (state, action) => {
            state.data = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })
        .addCase(getLead.fulfilled, (state, action) => {
            state.selectedLead = action.payload
        })
    }
})

export default appLeadsSlice.reducer
